import { defineComponent } from 'vue';
export default defineComponent({
    name: 'info-please-select-payout-condition',
});
